import { actionCreator, Joi, objectSchemaOf } from '../helpers';
import { DIALOGUE_INPUT } from './topics';
import type { IInteractionModePayload } from './interactionMode';
import { interactionModePayloadSchema } from './interactionMode';
import { forConversation } from '../channels';

export const REQUEST_INTERACTION_MODE = 'DIALOGUE/REQUEST_INTERACTION_MODE';

export interface IRequestInteractionModeAction {
  type: typeof REQUEST_INTERACTION_MODE;
  payload: IInteractionModePayload;
}

export const requestInteractionModeActionSchema = objectSchemaOf<IRequestInteractionModeAction>(
  {
    type: Joi.string().valid(REQUEST_INTERACTION_MODE).required(),
    payload: interactionModePayloadSchema.required(),
  }
);

export const requestInteractionMode = actionCreator({
  type: REQUEST_INTERACTION_MODE,
  schema: requestInteractionModeActionSchema,
  topic: DIALOGUE_INPUT,
  channels: [forConversation],
});
